<template>
  <div class="rounded-button-container">
    <button @click="onClick && onClick()">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.rounded-button-container {
  width: 100%;

  & button {
    background-color: $blue;
    color: $white;
    border: none;
    border-radius: 50px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    outline: none;
    text-transform: uppercase;
    width: 100%;
    height: 100%;

    &:hover {
      background-color: $highlight-blue;
    }

    &:active {
      background-color: $lowlight-blue;
    }
  }
}
</style>
